import Loader from "components/DesignSystem/Loader/loader";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { TaxOthers } from "pages/TaxOthers/TaxOthers";
import { Redirect } from "react-router-dom";
import { IncorporationCustomerView } from "./IncorporationCustomerView/IncorporationCustomerView";

export const IncorporationRoute = () => {
  const { uuid, is_pre_incorporate, has_published_incorporation_form } =
    useCurrentGroupContext();

  if (!uuid) {
    return <Loader />;
  }

  if (!is_pre_incorporate) {
    return <Redirect to="/tax/filings" />;
  }

  if (has_published_incorporation_form) {
    return <IncorporationCustomerView />;
  }

  return <TaxOthers type="incorporation" />;
};
